
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.857 6.338c.518-.698.703-1.434.117-2.084C8.66 2.414 7.775 1.276 7.22.73 6.166-.313 4.431-.172 3.518.728c-.49.483-.657.649-1.16 1.16C-.449 4.697 1.262 10.63 5.81 15.184c4.548 4.552 10.482 6.264 13.293 3.45.465-.447.858-.841 1.169-1.169.895-.946 1.03-2.604-.006-3.682-.532-.552-1.617-1.393-3.534-2.765-.587-.525-1.284-.411-1.922.007-.307.202-.53.406-.953.828l-.766.767c-.1.1-1.471-.586-2.801-1.917C8.96 9.37 8.274 7.999 8.374 7.899l.767-.768c.134-.134.198-.198.28-.285.171-.18.313-.343.436-.508zm4.649 7.695l.766-.767c.232-.232.383-.375.505-.474 1.68 1.206 2.653 1.965 3.05 2.378.239.248.202.7-.006.919-.287.303-.66.677-1.117 1.118-1.818 1.819-6.608.437-10.479-3.438C3.353 9.893 1.972 5.103 3.776 3.297c.502-.509.66-.668 1.144-1.144.182-.179.676-.22.896-.001.427.422 1.22 1.436 2.385 3.06-.06.074-.136.159-.228.255-.067.071-.123.128-.246.25l-.766.767c-1.303 1.303-.193 3.52 1.916 5.632 2.107 2.11 4.326 3.22 5.629 1.917z","fill":"#595959"}})])
          )
        }
      }
    